import { normalizeApplicationError } from "../shared/errors";
import type { ApplicationError } from "../shared/errors";
import type { RemoteState } from "../shared/types/contracts";

export const remoteLoading = <T>(): RemoteState<T> => ({ status: "loading" });

export const remoteAbsent = <T>(): RemoteState<T> => ({ status: "absent" });

export const remoteSuccess = <T>(data: T): RemoteState<T> => ({
  status: "success",
  data,
});

export const remoteFailure = <T>(error: unknown): RemoteState<T> => ({
  status: "failure",
  error: normalizeApplicationError(error),
});

export function remoteValue<T>(state: RemoteState<T>): T | null | undefined {
  if (state.status === "success") return state.data;
  if (state.status === "absent") return null;
  return undefined;
}

export function remoteError<T>(state: RemoteState<T>): ApplicationError | null {
  return state.status === "failure" ? state.error : null;
}
